
export const SYSTEM_ID=1;
export const SYSTEM_MENU_ID=0;

export const UNAUTHORIZZED_ERROR = 'Error 401 {"message":"Unauthorized"}';
export const REDIRECT_PAGE_MENU_ID = 3;
//Chart Map
export const SYSTEM_ID_MEDICAL_CORE_ID= 3;
export const SYSTEM_ID_MEDICAL_CORE_TEXT= 'MEDICAL CORE';

export const SYSTEM_ID_SECURITY= 2;
export const SYSTEM_ID_MEDICAL_SECURITY_TEXT= 'SECUIRTY';

export const CAPTCHA_SITE_KEY_2 = "6LcRpYMrAAAAAGRTzVuJdLd_RkGkP0ViD83ovzXg"

export const CAPTCHA_SITE_KEY = "6Lf004QrAAAAAKHlVO70JQ-5lQ0ouuIDaJJYc4zz"

export const SYSTEM_ID_MOTOR_CORE_ID= 16;
export const SYSTEM_ID_MOTOR_CORE_TEXT= 'MOTOR CORE';